{
  "success": true,
  "errorMessage": "",
  "list": [
    {
      "code": "065",
      "desc": "Russian Federation",
      "schemes": "5006,5007"
    }
  ]
}
